export default __webpack_public_path__ + "static/media/expressjs.8734b7eb.png";